<div class="mt-4">
  <div class="d-flex justify-content-between">
    <div>
      <searcher
        [label]="'Buscar Auditado'"
        (onChange)="search($event)"
        [showLoading]="showLoading"
      ></searcher>
    </div>
    <div>
      <button (click)="create()" class="create-button" *ngIf="canCreate">
        Crear Auditado
      </button>
    </div>
  </div>

  <app-table
    [data]="clientList"
    [displayedColumns]="columns"
    [columnsNames]="columnsNames"
    (update)="update($event)"
    [total]="total"
    [offset]="offset"
    [limit]="limit"
    (delete)="delete($event)"
    (onPageChange)="handlePageChange($event)"
  ></app-table>
</div>
